module.exports = __webpack_public_path__ + "img/new.254f55e1.webp";